import { Inject, Injectable, Optional } from '@angular/core';
import { from, Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ProductBySlugGQL } from '@shared/services/products/graphql/product-by-slug.gql.service';
import { map, concatMap, take, catchError } from 'rxjs/operators';
import { IProduct } from '@collections/products/interfaces';
import { StandService } from 'app/stand/stand.service';
import { ErrorService } from 'app/error-handler/services/error.service';
import { PageNotFoundError } from 'app/error-handler/custom-errors/page-not-found.error';
import { RESPONSE } from '../../../../express.tokens';

@Injectable()
export class ProductDetailsResolver  {
  constructor(
    private standService: StandService,
    private productBySlugGQL: ProductBySlugGQL,
    private router: Router,
    private errorService: ErrorService,
    @Optional() @Inject(RESPONSE) private res: any,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IProduct> {
    const slug = route.paramMap.get('slug');
    const lang = this.standService.currentLanguageCode;
    return this.standService.getCurrentCompany()
      .pipe(
        concatMap(company => {
          return this.productBySlugGQL.fetch(
            { companyId: company._id, lang: lang, slug: slug },
            { fetchPolicy: 'network-only' }
          )
            .pipe(
              map((result) => {
                const product = result.data.productBySlug;
                if (!product) {
                  throw new PageNotFoundError(state.url);
                }
                if (product.slug !== slug) {
                  const effectiveUrl = state.url.replace(slug, product.slug);
                  // il nome prodotto è stato cambiato, rispetto a quello indicizzato nei
                  // motori di ricerca, per cui va effettuato il redirect 301
                   this.router.navigate([effectiveUrl]);
/*                  if (this.res) {
                    this.res.redirect(301, effectiveUrl);
                    this.res.end();
                  } else {
                    prima il router.navigate era qui
                  } */
        
                } else {
                  return product;
                }
              }),
              catchError((err) => {
                return from(this.errorService.handleError(err));
              })
            );
        }),
        take(1),
        catchError((err) => {
          return from(this.errorService.handleError(err));
        })
      );
  }
}
